'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PlaceholderThumbnail = props => /*#__PURE__*/React__default["default"].createElement("svg", _extends__default["default"]({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 80 65"
}, props), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M49.4 19.5c-1.2 0-2.1-1-2.1-2.1 0-1.2 1-2.1 2.1-2.1 1.2 0 2.1 1 2.1 2.1 0 1.2-.9 2.1-2.1 2.1zm0-7.8c-3.1 0-5.7 2.6-5.7 5.7s2.6 5.7 5.7 5.7 5.7-2.6 5.7-5.7-2.6-5.7-5.7-5.7zm27.1 32.1L63.1 26.5c-.3-.4-.7-.6-1.2-.7-.5-.1-.9.1-1.3.4L47.1 37 29.2 14.2c-.6-.8-1.7-.9-2.5-.3L3.5 31.7V10.6c0-3.9 3.2-7.1 7.1-7.1h58.7c3.9 0 7.1 3.2 7.1 7.1v33.2zm0 10.1c0 3.9-3.2 7.1-7.1 7.1H10.6c-3.9 0-7.1-3.2-7.1-7.1V36.2l24-18.5 17.9 22.8c.3.4.7.6 1.2.7.5.1.9-.1 1.3-.4L61.4 30l15 19.5.1 4.4zM69.4 0H10.6C4.8 0 0 4.8 0 10.6v43.2c0 5.9 4.8 10.6 10.6 10.6h58.7c5.9 0 10.6-4.8 10.6-10.6V10.6C80 4.8 75.2 0 69.4 0z",
  fill: "#ccc"
}));

exports["default"] = PlaceholderThumbnail;
